import React from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
import GoogleAnalyticsScript from "components/GoogleAnalyticsScript";
import Routers from "./routes/Routers";
const CloseButton = ({ closeToast }) => (
  <i
    onClick={closeToast}
    className="la la-close notifications-close"
  />
);
function App() {
  return (
    <HelmetProvider>
      <ToastContainer
        position="bottom-left"
        autoClose={2000}
        hideProgressBar={false}
        closeButton={<CloseButton />}
      />
      <GoogleAnalyticsScript />
      <Routers />
    </HelmetProvider>
  );
}
export default App;
